/* Marketplace API — search, compare, save offers. */
import { USE_MOCK_API } from './httpClient'
import * as mock from './marketplace.mock'
import * as http from './marketplace.http'
import type {
  MarketplaceSearchResult,
  MarketplaceRecommendation,
  MarketplaceCategory,
} from './types'

const impl = USE_MOCK_API ? mock : http

export type { MarketplaceOffer, MarketplaceSearchResult, MarketplaceRecommendation, MarketplaceCategory } from './types'

export const searchMarketplace = impl.searchMarketplace
export const compareMarketplace = impl.compareMarketplace
export const getMarketplaceRecommendations = impl.getMarketplaceRecommendations
export const saveMarketplaceOffer = impl.saveMarketplaceOffer
export const createTripFromTemplate = impl.createTripFromTemplate
